var _ = require('lodash');
var defaults = require('./defaults');

module.exports =  _.merge(defaults, {
    name: 'Stage',
    allowDebugLogs: true,
    listreportsUrl: 'https://stage.listreports.com',
    google: {
        apiKey: 'AIzaSyAC7drds0lTeA5twaMUpngVfLe4ubjsEVU'
    },
    listhub: {
        meterics_provider_id: 'M-5391',
        test: true
    },
    mixpanel: {
        id: 'fe73427da4e18cc1f16dc8acbf93bb83',
        debug: true
    },
    babou: {
        apiKey: 'xJxZo1Q9qi7Lu8I0E3VTm2Bcat3DLzQd9WVKXI3d',
        url: 'https://babou.stage.listreports.com/v1'
    },
    whats_my_home_worth: {
        agent: 'Hk_K1P8ll',
        vendor: 'r1fLr2ZEe'
    },
    themesUrl: 'https://templates.stage.listreports.com/assets/themes-config.json'
});
